if (!customElements.get('button-carousel')) {
    class ButtonCarousel extends HTMLElement {
      constructor() {
        super();
      }
  
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.buttons__items',
          pagination: '.swiper-pagination',
          nextEl: '.swiper-btn-next',
          prevEl: '.swiper-btn-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };
  
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
  
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = parseInt(this.dataset.items);
        this.tabletItems = parseInt(this.dataset.tabletItems);
  
        this.sliderInstance = false;
  
        if (!this.enableSlider) return;
  
        this.init();
        document.addEventListener('matchMobile', () => {
          this.init();
        });
        document.addEventListener('unmatchMobile', () => {
          this.init();
        });
      }
  
      init() {
        this.initSlider();
      }
  
      initSlider() {  
        const navigationNext = this.closest('.collection__links')?.querySelector('.swiper-button-next');

        const sliderOptions = {slidesPerView: "auto",
            spaceBetween: 15,
            loop: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            navigation: {
              nextEl: navigationNext || this.querySelector('.swiper-button-next'),
              prevEl: ".swiper-button-prev",
            },
        };
  
        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.remove(this.classes.grid);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
          this.sliderInstance.init();
  
          const focusableElements = FoxTheme.a11y.getFocusableElements(this);
  
          focusableElements.forEach((element) => {
            element.addEventListener('focusin', () => {
              const slide = element.closest('.swiper-slide');
              this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
            });
          });
        }
        if (Shopify.designMode && typeof this.sliderInstance === 'object') {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);
  
            this.sliderInstance.slider.slideToLoop(index);
          });
        }
      }
  
      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy();
          this.sliderInstance = false;
        }
      }
    }
    customElements.define('button-carousel', ButtonCarousel);
  }